/** guardian/family — KEYS. Query-key factory. */

export const guardianFamilyKeys = {
  all: () => ['guardian-family'] as const,
  overview: () => [...guardianFamilyKeys.all(), 'overview'] as const,
  devices: () => [...guardianFamilyKeys.all(), 'devices'] as const,
};
